import { ApplicationRef, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { interval, Subscription } from 'rxjs';
import { BrowserService } from './core/browser.service';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { PageviewlogService } from './core/services/pageview-log.service';
import { environment } from './../environments/environment';

@Component({
  selector: 'brf-news-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy, OnInit {
  title = 'BRF-Mappen';
  subs = new Subscription();
  updateSubscriptionWasRegistered = false;

  constructor(private browserService: BrowserService, private appRef: ApplicationRef, private update: SwUpdate, private router: Router, private pageviewlogService: PageviewlogService) {
    if (this.browserService.isbrowser) {
      if ((location.hostname && location.hostname.startsWith('www.')) || location.pathname.startsWith('/suppliers')) {
        let newPath = location.href.replace('//www.', '//').replace('/suppliers', '/hitta-leverantor');
        location.replace(newPath);
      }
      const flag = window?.innerWidth < 760;
      this.browserService.isMobileScreenSubject.next(flag);
      this.browserService.isDesktopScreenSubject.next(!flag);

      window['isFirstLoad'] = true;
      window['isRequiredReloadWhenNavigate'] = false;

      this.updateClient();
      this.checkUpdate();

      this.subs.add(
        this.router.events.subscribe((val: any) => {
          if (this.browserService.isbrowser) {
            if (val instanceof NavigationStart && window['isRequiredReloadWhenNavigate'] == true) {
              console.log('Reloading...');
              window['isRequiredReloadWhenNavigate'] = false;
              setTimeout(() => {
                location.reload();
              }, 100);
            }
          }
        })
      );

      const fbPixelId = environment.fbPixelId;
      var t = document.createElement('script');
      t.type = 'text/javascript';
      t.id = 'scriptFBPixel';
      t.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window,document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${fbPixelId}');
        fbq('track', 'PageView');`;
      const existingScriptTag = document.getElementById(t.id);
      if (!existingScriptTag) document.body.appendChild(t);
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  ngOnInit() {
    this.setUpOurOwnAnalytics();
    console.log('ng v15 working !!!');
  }

  setUpOurOwnAnalytics() {
    this.subs.add(
      this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: any) => {
        if (this.browserService.isbrowser) {
          this.pageviewlogService.capturePageview(event?.urlAfterRedirects).subscribe();
        }
      })
    );
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    const flag = window?.innerWidth < 760;
    this.browserService.isMobileScreenSubject.next(flag);
    this.browserService.isDesktopScreenSubject.next(!flag);
  }

  updateClient() {
    if (this.updateSubscriptionWasRegistered) return;
    this.updateSubscriptionWasRegistered = true;

    if (!this.update.isEnabled) {
      console.log('Update not Enabled');
      return;
    }

    console.log('Registering subscription for watching update...');
    this.subs.add(
      this.update.available.subscribe(event => {
        console.log(`current`, event.current, `available `, event.available);
        if ('serviceWorker' in navigator) {
          navigator.serviceWorker.getRegistrations().then(function (registrations) {
            let pArr: Promise<boolean>[] = [];
            for (let registration of registrations) {
              pArr.push(registration.unregister());
            }
            if ('caches' in window) {
              caches.keys().then(function (keyList) {
                for (let k of keyList) pArr.push(caches.delete(k));
              });
            }
            Promise.all(pArr).then(result => {
              console.log('Cleared all cached data.');
              window['isRequiredReloadWhenNavigate'] = true;
            });
          });
        }
      })
    );
  }

  checkUpdate() {
    this.subs.add(
      this.appRef.isStable.subscribe(isStable => {
        if (isStable) {
          const timeInterval = interval(2 * 60 * 60 * 1000);

          timeInterval.subscribe(() => {
            this.update.checkForUpdate().then(() => {});
          });
        }
      })
    );
  }

  onActivate(event) {
    if (this.browserService.isbrowser) {
      setTimeout(() => {
        window.scroll({
          top: 10,
          left: 10,
          behavior: 'smooth'
        });
      }, 0);
    }
  }
}
